// extracted by mini-css-extract-plugin
export default {"block":"AccountView_block__ajV7U","photo":"AccountView_photo__3dEG1","info":"AccountView_info__+lCcb","title":"AccountView_title__eGurC","list__item":"AccountView_list__item__jHlT7"};